export default __webpack_public_path__ + "static/media/delivery.7e839a67.svg";